<template>
  <v-autocomplete
    hide-details="auto"
    :items="categories"
    :loading="loadingCategories"
    v-model="filterDatas.category"
    item-text="name"
    item-value="id"
    label="Categories"
    outlined
    dense
    @change="emitInput(filterDatas.category)"
    clearable
    :search-input.sync="searchCategory"
  ></v-autocomplete>
</template>
<script>
import { mapState } from 'vuex';

export default {
  props: {
    clear: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    categories: [],
    loadingCategories: false,
    selectCategory: null,
    searchCategory: null,
  }),
  computed: {
    ...mapState(['filterDatas']),
  },
  methods: {
    emitInput(data) {
      if (this.filterDatas.isrouteNewPage == false) {
        this.$store.commit('UPDATE_CATEGORY_FILTER', data);

        this.$emit('input', this.filterDatas.category);
      } else {
        this.$emit('input', data);
      }
    },
    GetCategoryByQuery(query = '') {
      this.loadingCategories = true;
      this.$store
        .dispatch('product/GetCategorySearch', {
          query:
            this.filterDatas.isrouteNewPage == false
              ? this.filterDatas.categoryquery
              : query,
        })
        .then((res) => {
          this.categories = res.data.data;
          this.loadingCategories = false;
        })
        .catch((err) => {
          this.loadingCategories = false;
          this.messages = err.data.name;
        });
    },
  },
  watch: {
    clear: {
      handler(val) {
        this.selectCategory = null;
        this.searchCategory = null;
      },
      deep: true,
    },
    searchCategory: {
      handler(val) {
        if (this.filterDatas.isrouteNewPage == false) {
          this.$store.commit('UPDATE_CATEGORY_QUERY_FILTER', val);
        }
        this.GetCategoryByQuery(val);
      },
      deep: true,
    },
  },
  mounted() {
    if (this.filterDatas.isrouteNewPage == false) {
      this.selectCategory = this.filterDatas.category;
      this.$emit('input', this.filterDatas.category);
    }
  },
  created() {
    this.GetCategoryByQuery();
  },
};
</script>
